import { Skeleton } from "@/components/ui/skeleton";

/** Suspense fallback while the lazily imported calendar chunk downloads. */
export function CalendarSkeleton() {
	return (
		<div>
			<div className="mb-3 flex items-center gap-2">
				<Skeleton className="h-9 w-20" />
				<Skeleton className="h-5 w-36" />
				<Skeleton className="ml-auto h-7 w-16" />
			</div>
			<div className="grid grid-cols-7 overflow-hidden rounded-lg border-l border-t border-border">
				{Array.from({ length: 42 }).map((_, i) => (
					<div
						key={i}
						className="min-h-28 border-b border-r border-border p-1.5"
					>
						<Skeleton className="h-5 w-5 rounded-full" />
					</div>
				))}
			</div>
		</div>
	);
}
